// iOS-safe body scroll lock, reference counted so nested sheets cannot unlock
// each other. Replaces the ad-hoc `document.body.style.overflow` toggling.

let depth = 0
let savedY = 0

const LOCK_STYLES = ['position', 'top', 'left', 'right', 'width', 'overflow']

export function lock() {
    if (depth++ !== 0) return
    savedY = window.scrollY || window.pageYOffset || 0
    const body = document.body.style
    body.position = 'fixed'
    body.top = `-${savedY}px`
    body.left = '0'
    body.right = '0'
    body.width = '100%'
    body.overflow = 'hidden'
}

export function unlock() {
    if (depth === 0) return
    if (--depth !== 0) return
    const body = document.body.style
    for (const prop of LOCK_STYLES) body[prop] = ''
    window.scrollTo(0, savedY)
}

// Escape hatch for teardown paths (component unmounted while locked).
export function isLocked() {
    return depth > 0
}

export const useScrollLock = () => ({ lock, unlock, isLocked })
